import React from 'react';

import styles from '../../styles/views/components/CommentsHeader.module.scss';

const CommentsHeader = () => (
  <div className={styles.commentsHeader}>
    {t('comments.title', { ns: i18next.Namespace.COMMON })}
    <hr />
  </div>
);

export default CommentsHeader;
